import { formatINR } from "@/lib/quotationApi";

/**
 * Sticky-bottom totals row. Shows per-tier sum + rounded average of
 * effective ₹/sqft across all finishes.
 */
export default function FinishesTotalsRow({ orderedTiers, columnStats, finishCount }) {
  return (
    <tfoot data-testid="finishes-totals-row">
      <tr className="border-t-2 border-white/10">
        <th
          className="sticky bottom-0 left-0 z-30 bg-[#0F1013]/98 backdrop-blur px-3 py-3 text-left align-top"
          scope="row"
        >
          <div className="text-[10px] uppercase tracking-wider text-white/50 font-medium">
            Column totals
          </div>
          <div className="text-[10px] text-white/35 mt-0.5">
            {finishCount} {finishCount === 1 ? "finish" : "finishes"}
          </div>
        </th>
        {orderedTiers.map((tier) => {
          const s = columnStats[tier.id] || { sum: 0, avg: 0 };
          return (
            <td
              key={tier.id}
              className="sticky bottom-0 z-20 bg-[#0F1013]/98 backdrop-blur px-3 py-3 border-l border-white/5 align-top"
              data-testid={`total-${tier.id}`}
            >
              <div
                className="text-sm font-semibold leading-tight"
                style={{ color: tier.color || "#C5A880" }}
              >
                {formatINR(s.sum)}
              </div>
              <div className="text-[10px] text-white/40 mt-0.5">
                avg {formatINR(Math.round(s.avg))}
              </div>
            </td>
          );
        })}
      </tr>
    </tfoot>
  );
}
